module.exports = __webpack_public_path__ + "static/J2021_JFM_abs-fd0222a42ef8c7f40b99bf659dd3f190.jpg";